'use client'

import { BookOpen, FileText,  School, Target } from 'lucide-react'
import { Link } from 'react-router-dom'
import DashboardLayout from '../../dashboard/DashboardLayout'
import { Button } from '@/components/ui/common/Button'
export default function MaturzysciPage() {
  return (
    <DashboardLayout>
      <div className="p-6">
        <div className="space-y-8">
          <div className=" ">
          
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              <div className="border border-green-200 bg-green-50 p-4 flex flex-col h-full">
                <div className="mb-2 flex items-center">
                  <Target className="mr-2 h-5 w-5 text-green-600" />
                  <h3 className="font-medium text-gray-900">Proponowane zawody</h3>
                </div>
                <p className="mb-3 text-sm text-gray-600 flex-grow">
                  Zawody dopasowane do Twoich predyspozycji
                </p>
                <Link to="/high-school-graduates/proposed-professions">
                  <Button className="w-full border-gray-200 bg-white border-1" size="sm" variant="outline">
                    Przeglądaj zawody
                  </Button>
                </Link>
              </div>

              <div className="border border-purple-200 bg-purple-50 p-4 flex flex-col h-full">
                <div className="mb-2 flex items-center">
                  <BookOpen className="mr-2 h-5 w-5 text-purple-600" />
                  <h3 className="font-medium text-gray-900">Kierunki studiów</h3>
                </div>
                <p className="mb-3 text-sm text-gray-600 flex-grow">Polecane kierunki studiów</p>
                <Link to="/high-school-graduates/fields-of-study">
                  <Button className="w-full border-gray-200 bg-white border-1" size="sm" variant="outline">
                    Zobacz kierunki
                  </Button>
                </Link>
              </div>

              <div className="  border border-orange-200 bg-orange-50 p-4 flex flex-col h-full">
                <div className="mb-2 flex items-center">
                  <FileText className="mr-2 h-5 w-5 text-orange-600" />
                  <h3 className="font-medium text-gray-900">Przedmioty maturalne</h3>
                </div>
                <p className="mb-3 text-sm text-gray-600 flex-grow">
                  Wymagane przedmioty na maturze
                </p>
                <Link to={'/high-school-graduates/graduate-lessons'}>
                  <Button className="w-full border-gray-200 bg-white border-1" size="sm" variant="outline">
                    Sprawdź wymagania
                  </Button>
                </Link>
              </div>

              <div className="  border border-indigo-200 bg-indigo-50 p-4 flex flex-col h-full">
                <div className="mb-2 flex items-center">
                  <School className="mr-2 h-5 w-5 text-indigo-600" />
                  <h3 className="font-medium text-gray-900">Baza uczelni</h3>
                </div>
                <p className="mb-3 text-sm text-gray-600 flex-grow">Uczelnie wyższe w Polsce</p>
                <Link to="/high-school-graduates/university-base">
                  <Button className="w-full border-gray-200 bg-white border-1" size="sm" variant="outline">
                    Szukaj uczelni
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
